'use client'
import { FC, PropsWithChildren } from 'react'
import cn from 'classnames'
import { FieldPath, FieldValues, UseFormRegister } from 'react-hook-form'

import { Checkbox } from '@/components/Checkbox'

import styles from './AcceptCheckbox.module.scss'

interface AcceptCheckboxProps<TFormData extends FieldValues> {
  className?: string
  register: UseFormRegister<TFormData>
  error?: string
}
export const AcceptCheckbox = <TFormData extends FieldValues>({
  className,
  register,
  error,
}: AcceptCheckboxProps<TFormData>) => {
  const name = 'accept' as FieldPath<TFormData>

  return (
    <Checkbox
      className={cn(className, styles.cotnainer)}
      error={error}
      {...register(name)}
    >
      <span className={styles.checkboxLabel}>
        Я принимаю условия{' '}
        <Link href="/documents/policy">
          политики обработки персональных данных
        </Link>{' '}
        сайта и{' '}
        <Link href="/documents/user-agreement">
          пользовательского соглашения
        </Link>
        , а также даю{' '}
        <Link href="/documents/processing-personal-data">
          согласие на обработку персональных данных
        </Link>{' '}
        и{' '}
        <Link href="/documents/agreement-advertising-information-materials">
          согласие на информационные рассылки
        </Link>
      </span>
    </Checkbox>
  )
}

interface LinkProps {
  href: string
}
const Link: FC<PropsWithChildren<LinkProps>> = ({ href, children }) => {
  return (
    <a href={href} target="_blank" className={styles.link}>
      {children}
    </a>
  )
}
